<template>

<div>
	<div class="header">
		<img v-if="getClient.logo_src" :src="getClient.logo_src">
		<div v-else>{{ getClient.company_name }}</div>
		<h1>Firearms Transaction Record, Form 4473 (pre-2020)</h1>
	</div>

	<div class="login" v-if="!user.user_id" v-cloak>
		<h2>Manager Login</h2>
    	<div class="content">
			<label>Username</label>
			<input type="text" v-model="username">
			<label>Password</label>
			<input type="password" v-model="password" @keyup.enter="doLogin">
		</div>
		<div class="controls">
			<div class="button action" @click="doLogin">Login</div>
			<span class="loading" v-if="loading"><i class="fas fa-spinner fa-spin"></i></span>
		</div>
		<div class="message">{{ message }}</div>
		<div class="note">Please have a manager log in.</div>

		<router-link to="/logbooks/customer-4473" class="note">Need to start Customer Section B or Section D?</router-link>

	</div>

	<div class="form-options" v-else-if="!formOption" v-cloak>
		<!-- <div class="options">
			<h2>New Form 4473</h2>
			<p>Start a new Form 4473 by searching your dispositions to find the Transferee/Buyer information...</p>
			<div class="three-one-columns">
				<div class="input-with-control">
					<input type="text" v-model="search_disposals" placeholder="Search dispositions..." @keyup.enter="searchDisposals">
					<div class="button action input-go" @click="searchDisposals"><i class="fas fa-search"></i></div>
				</div>
				<button class="button action" @click="doFormNew">New</button>
			</div>
			<div class="search-result bordered">
				<ul v-if="disposals && disposals.length != 0" class="search-list">
					<li class="clickable-list-item" v-for="(disposal, index) in disposals" @click="assignDisposal(disposal)" :key="index">
						<span>{{ disposal.date_created }}</span>
						<span>{{ disposal.full_name || fullName(disposal) }}</span>
						<span>{{ disposal.address_1 }}</span>
						<span>{{ disposal.city }}, {{ disposal.state }} {{ disposal.zip_code }}</span>
						<span v-if="disposal.ffl_number">{{ disposal.ffl_number }}</span>
					</li>
				</ul>
				<div v-else-if="disposalSearchMessage" class="no-results">{{ disposalSearchMessage }}</div>
			</div>
		</div> -->
		<div class="options">
			<h2>Customer Section C</h2>
			<p>Look up a <b>pre-2020</b> 4473 so your customer can complete Section C immediately prior to the transfer...</p>
			<div class="input-with-control">
				<input type="text" v-model="search_forms" placeholder="Search pre-2020 4473s by customer..." @keyup.enter="searchForms">
				<div class="button action input-go" @click="searchForms"><i class="fas fa-search"></i></div>
			</div>
			<div class="search-result bordered">
				<ul v-if="forms && forms.length != 0" class="search-list">
					<li class="clickable-list-item" v-for="(form, index) in forms" @click="assignForm(form)" :key="index">
						<span>{{ form.date_created }}</span>
						<span>{{ form.form_data.full_name || fullName(form.form_data) }}</span>
						<span>{{ form.form_data.address_1 }}</span>
						<span>{{ form.form_data.city }}, {{ form.form_data.state }} {{ form.form_data.zip_code }}</span>
						<span v-if="form.ffl_number">{{ form.form_data.ffl_number }}</span>
					</li>
				</ul>
				<div v-else-if="formSearchMessage" class="no-results">{{ formSearchMessage }}</div>
			</div>
		</div>
		<div class="options">
			<h2>Return to Login screen</h2>
			<div class="button action" @click="logOut">Log Out</div>
		</div>
	</div>

	<div v-else-if="formIncomplete" v-cloak>
		<div class="intro-content">
			<p class="light-font" style="margin-bottom: 1em;">WARNING: You may not receive a firearm if prohibited by Federal or State Law. The Information you provide will be used to determine whether you are prohibited under law from receiving a firearm. Certain violations of the Gun Control Act, 18 U.S.C. 921 et.seq., are punishable by up to 10 years imprisonment and/or up to a 250,000 fine.</p>
			<p class="light-font" style="margin-bottom: 2em;">Read the Notices, Instructions, and Definitions on this form. Prepare in original only at the licensed premises ("licensed premises" includes business temporarily conducted from a qualifying gun show or event in the same State in which the licensed premises is located) unless the transaction qualifies under 18 U.S.C. 922(c).</p>
			<h2>Purpose of the Form</h2>
			<p>Purpose of the Form: The information and certification on this form are designed so that a person licensed under 18 U.S.C. 923 may determine if he/she may lawfully sell or deliver a firearm to the person identified in Section A, and to alert the transferee/buyer of certain restrictions on the receipt and possession of firearms. The transferor/seller of a firearm must determine the lawfulness of the transaction and maintain proper records of the transaction. Consequently, the transferor/seller must be familiar with the provisions of 18 U.S.C. 921-931 and the regulations in 27 CFR Parts 478 and 479. In determining the lawfulness of the sale or delivery of a rifle or shotgun to a resident of another State, the transferor/seller is presumed to know the applicable State laws and published ordinances in both the transferor's/seller's State and the transferee's/buyer's State. (See ATF Publication 5300.5, State Laws and Published Ordinances.)</p>
			<div class="help-box-outer form-full" style="margin-top: 2em;">
				<div :class="['help-box-label', showHelp.indexOf('p') > -1 ? 'help-box-label-live' : '']" style="margin-top: -1.55em;" @click="toggleHelp('p')">Read More</div>
				<div class="help-box" v-show="showHelp.indexOf('p') > -1">
					<p>Generally, ATF Form 4473 must be completed at the licensed business premises when a firearm is transferred over-the-counter. Federal law, 18 U.S.C. 922(c), allows a licensed importer, manufacturer, or dealer to sell a firearm to a nonlicensee who does not appear in person at the licensee's business premises only if the transferee/buyer meets certain requirements. These requirements are set forth in section 922(c), 27 CFR 478.96(b), and ATF Procedure 2013-2.</p>
					<p>After the transferor/seller has completed the firearms transaction, he/she must make the completed, original ATF Form 4473 (which includes the Notices, General Instructions, and Definitions), and any supporting documents, part of his/ her permanent records. Such Forms 4473 must be retained for at least 20 years and after that period may be submitted to ATF. Filing may be chronological (by date of disposition), alphabetical (by name of purchaser), or numerical (by transaction serial number), as long as all of the transferor's/seller's completed Forms 4473 are filed in the same manner.</p>
					<p>FORMS 4473 FOR DENIED/CANCELED TRANSFERS MUST BE RETAINED: If the transfer of a firearm is denied/canceled by NICS, or if for any other reason the transfer is not completed after a NICS check is initiated, the licensee must retain the ATF Form 4473 in his/her records for at least 5 years. Forms 4473 with respect to which a sale, delivery, or transfer did not take place shall be separately retained in alphabetical (by name of transferee) or chronological (by date of transferee's certification) order.</p>
					<p>If the transferor/seller or the transferee/buyer discovers that an ATF Form 4473 is incomplete or improperly completed after the firearm has been transferred, and the transferor/seller or the transferee/buyer wishes to correct the omission(s) or</p>
					<p>error(s), photocopy the inaccurate form and make any necessary additions or revisions to the photocopy. The transferor/seller should only make changes to Sections B and D. The transferee/buyer should only make changes to Section A and C. Whoever made the changes should initial and date the changes. The corrected photocopy should be attached to the original Form 4473 and retained as part of the transferor's/seller's permanent records.</p>
					<p>Exportation of Firearms: The State or Commerce Departments may require a firearms exporter to obtain a license prior to export. Warning: Any person who exports a firearm without proper authorization may be fined not more than $1,000,000 and/or imprisoned for not more than 20 years. See 22 U.S.C. 2778(c).</p>
				</div>
			</div>

			<h1>Section A</h1>
			<h2>Must be Completed Personally by Transferee/Buyer</h2>

			<p class="dark-font">When the transferee/buyer of a firearm is a corporation, company, association, partnership, or other such business entity, an officer authorized to act on behalf of the business must complete Section A of the form with his/her personal information, sign Section A, and attach a written statement, executed under penalties of perjury, stating: (A) the firearm is being acquired for the use of and will be the property of that business entity; and (B) the name and address of that business entity.</p>
			<div class="help-box-outer form-full" style="margin-top: 2em;">
				<div :class="['help-box-label', showHelp.indexOf(0) > -1 ? 'help-box-label-live' : '']" style="margin-top: -1.55em;" @click="toggleHelp(0)">Instructions</div>
				<div class="help-box" v-show="showHelp.indexOf(0) > -1">
					<p>The transferee/buyer must personally complete Section A of this form and certify (sign) that the answers are true, correct, and complete. However, if the transferee/ buyer is unable to read and/or write, the answers (other than the signature) may be completed by another person, excluding the transferor/seller. Two persons (other than the transferor/seller) must then sign as witnesses to the transferee's/buyer's answers and signature/certification in question 14.</p>
					<p>When the transferee/buyer of a firearm is a corporation, company, association, partnership, or other such business entity, an officer authorized to act on behalf of the business must complete Section A of the form with his/her personal information, sign Section A, and attach a written statement, executed under penalties of perjury, stating: (A) the firearm is being acquired for the use of and will be the property of that business entity; and (B) the name and address of that business entity.</p>
				</div>
			</div>
		</div>

		<!-- <div class="form-content" :class="{ 'show-help': showHelp }"> -->
		<div class="form-content">
			<div class="form-full">
				<p class="light-font">1. Transferee/Buyer's Full Name</p>
			</div>

			<div class="form-half">
				<label class="dark-font" id="first_name">First Name</label>
				<input type="text" v-model="contact.first_name" :disabled="formDisabled">
			</div>

			<div class="form-quarter">
				<label class="dark-font checkbox" id="first_initial">
					<input type="checkbox" class="half-input" v-model="form_data.first_initial" :disabled="formDisabled">
					<span>
						<i class="fas fa-check-circle"></i>
						First Name is Initial Only
					</span>
				</label>
			</div>

			<div class="form-half">
				<label class="dark-font" id="middle_name">Middle Name</label>
				<input type="text" v-model="contact.middle_name" :disabled="formDisabled">
			</div>

			<div class="form-quarter">
				<label class="dark-font checkbox" id="middle_initial">
					<input type="checkbox" class="half-input" v-model="form_data.middle_initial" :disabled="formDisabled">
					<span>
						<i class="fas fa-check-circle"></i>
						Middle Name is Initial Only
					</span>
				</label>
			</div>

			<div class="form-quarter">
				<label class="dark-font checkbox" id="middle_name_blank">
					<input type="checkbox" v-model="form_data.middle_name_blank" :disabled="formDisabled">
					<span>
						<i class="fas fa-check-circle"></i>
						No Middle Name
					</span>
				</label>
			</div>

			<div class="form-half">
				<label class="dark-font" id="last_name">Last Name</label>
				<input type="text" v-model="contact.last_name" :disabled="formDisabled">
			</div>

			<div class="form-quarter">
				<label class="dark-font" id="last_initial">Suffix e.g. Jr, Sr, II, III, if any</label>
				<input type="text" class="half-input" v-model="contact.suffix" :disabled="formDisabled">
			</div>

			<div class="form-quarter">
				<label class="dark-font checkbox" id="last_initial">
					<input type="checkbox" class="half-input" v-model="form_data.last_initial" :disabled="formDisabled">
					<span>
						<i class="fas fa-check-circle"></i>
						Last Name is Initial Only
					</span>
				</label>
			</div>

			<div class="help-box-outer form-full">
				<div :class="['help-box-label', showHelp.indexOf(1) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(1)">Instructions</div>
				<div class="help-box" v-show="showHelp.indexOf(1) > -1">
					<p class="light-font">Question 1. If legal name contains an initial only, enter in the Initial Only box. If no middle name, select No Middle Name.</p>
				</div>
			</div>

			<div class="form-full">
				<p class="light-font">2. Current State of Residence and Address (U.S.Postal abbreviations are acceptable. Cannot be a post office box.)</p>
			</div>

			<div class="form-half">
				<label class="dark-font" id="address_1">Number and Street Address</label>
				<input type="text" v-model="contact.address_1" :disabled="formDisabled">
			</div>

			<div class="form-half">
				<label class="dark-font" id="city">City</label>
				<input type="text" v-model="contact.city" :disabled="formDisabled">
			</div>

			<div class="form-half">
				<label class="dark-font" id="county">County</label>
				<input type="text" v-model="form_data.county" :disabled="formDisabled">
			</div>

			<div class="form-quarter">
				<label class="dark-font" id="state">State</label>
				<select v-model="contact.state">
				    <option value="null">State...</option>
				    <option v-for="(state, abbr) in this.STATES_LIST" :value="abbr">{{ state }}</option>
				</select>
			</div>

			<div class="form-quarter">
				<label class="dark-font" id="zip_code">Zip Code</label>
				<input type="text" v-model="contact.zip_code" :disabled="formDisabled">
			</div>

			<div class="form-full">
				<label class="dark-font">Are you a service member who is acquiring a firearm in a State where your permanent duty station is located, but reside in a different State?</label>
				<label class="dark-font checkbox">
					<input type="checkbox" v-model="extraAddress" :disabled="formDisabled">
					<span>
						<i class="fas fa-check-circle"></i>
						Yes
					</span>
				</label>
			</div>

			<template v-if="extraAddress">
			<div class="form-full">
				<p class="light-font">Home State and Address (U.S.Postal abbreviations are acceptable. Cannot be a post office box.)</p>
			</div>

			<div class="form-half">
				<label class="dark-font" id="address_1">Number and Street Address</label>
				<input type="text" v-model="form_data.home_address_1" :disabled="formDisabled">
			</div>

			<div class="form-half">
				<label class="dark-font" id="city">City</label>
				<input type="text" v-model="form_data.home_city" :disabled="formDisabled">
			</div>

			<div class="form-half">
				<label class="dark-font" id="county">County</label>
				<input type="text" v-model="form_data.home_county" :disabled="formDisabled">
			</div>

			<div class="form-quarter">
				<label class="dark-font" id="state">State</label>
				<select v-model="form_data.home_state">
				    <option value="null">State...</option>
				    <option v-for="(state, abbr) in this.STATES_LIST" :value="abbr">{{ state }}</option>
				</select>
			</div>

			<div class="form-quarter">
				<label class="dark-font" id="zip_code">Zip Code</label>
				<input type="text" v-model="form_data.home_zip_code" :disabled="formDisabled">
			</div>
			</template>

			<div class="help-box-outer form-full">
				<div :class="['help-box-label', showHelp.indexOf(2) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(2)">Instructions</div>
				<div class="help-box" v-show="showHelp.indexOf(2) > -1">
					<p>Question 2. Current Residence Address: A rural route (RR) may be accepted provided the transferee/buyer lives in a State or locality where it is considered a legal residence address. County and Parish are one and the same.</p>
					<p>If the transferee/buyer is a member of the Armed Forces on active duty, his/her State of residence is the State in which his/her permanent duty station is located. If the service member is acquiring a firearm in a State where his/her permanent duty station is located, but resides in a different State, the transferee/buyer must list both his/her permanent duty station address and his/her residence address in response to question 2. If the transferee/buyer has two States of residence, the transferee/ buyer should list his/her current residence address in response to question 2 (e.g., if the transferee/buyer is purchasing a firearm while staying at his/her weekend home in State X, he/she should list the address in State X in response to question 2).</p>
				</div>
			</div>

			<div class="form-full">
				<label class="light-font" id="place_of_birth">3. Place of Birth</label>
			</div>

			<div class="form-half">
				<label class="dark-font" id="birth_city">U.S. City</label>
				<input type="text" v-model="form_data.birth_city" :disabled="formDisabled">
			</div>

			<div class="form-quarter">
				<label class="dark-font" id="place_of_birth_state">State</label>
				<select v-model="form_data.customerValues.POB_CODE">
				    <option value="null">State...</option>
				    <option v-for="(state, abbr) in this.STATES_LIST" :value="abbr">{{ state }}</option>
				</select>
			</div>

			<div class="form-quarter line-break">
				<p class="dark-font">- OR -</p>
			</div>

			<div class="form-half line-break">
				<label class="dark-font" id="foreign_country">Foreign Country</label>
				<select v-model="form_data.foreign_country">
				    <option :value="null">Country...</option>
				    <option v-for="(country, code) in this.COUNTRIES_LIST" :value="code">{{ country }}</option>
				</select>
			</div>

			<div class="form-half line-break">
				<p class="light-font">4. Height</p>
			</div>

			<div class="form-quarter">
				<p class="light-font">5. Weight</p>
			</div>

			<div class="form-quarter">
				<label class="light-font" id="sex">6. Sex</label>
			</div>

			<div class="form-quarter line-break">
				<label class="dark-font" id="feet">Ft.</label>
				<input type="number" v-model="form_data.feet" :disabled="formDisabled">
			</div>

			<div class="form-quarter">
				<label class="dark-font" id="inches">In.</label>
				<input type="number" v-model="form_data.inches" :disabled="formDisabled">
			</div>

			<div class="form-quarter">
				<label class="dark-font" id="weight">Lbs.</label>
				<input type="number" v-model="form_data.customerValues.WEIGHT" :disabled="formDisabled">
			</div>

			<div class="form-quarter control-group">
				<label class="dark-font radio first">
					<input type="radio" v-model="form_data.customerValues.GENDER_CODE" value="M" :disabled="formDisabled">
					<span><i class="fas fa-check-circle"></i>Male</span>
				</label>
				<label class="dark-font radio last">
					<input type="radio" v-model="form_data.customerValues.GENDER_CODE" value="F" :disabled="formDisabled">
					<span><i class="fas fa-check-circle"></i>Female</span>
				</label>
			</div>

			<div class="form-full">
				<p class="light-font" id="birthdate">7. Birth Date</p>
			</div>

			<div class="form-half">
				<label class="dark-font" id="birthdate"></label>
				<input type="date" v-model="contact.birthdate" :disabled="formDisabled">
			</div>

			<div class="form-half line-break">
				<label class="light-font" id="SSN">8. Social Security Number (Optional, but will help prevent misidentification)</label>
				<input type="text" v-model="form_data.customerValues.SSN" :disabled="formDisabled">
			</div>

			<div class="form-half">
				<label class="light-font" id="upin">9. Unique Personal Identification Number (UPIN) if applicable</label>
				<input type="text" v-model="form_data.customerValues.UPIN" :disabled="formDisabled">
			</div>

			<div class="help-box-outer form-full">
				<div :class="['help-box-label', showHelp.indexOf(3) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(3)">Instructions</div>
				<div class="help-box" v-show="showHelp.indexOf(3) > -1">
					<p>Question 9. Unique Personal Identification Number (UPIN): For transferees/ buyers approved to have information maintained about them in the FBI NICS Voluntary Appeal File, NICS will provide them with a UPIN, which the transferee/ buyer should record in question 9. The licensee should provide the UPIN when conducting background checks through the NICS or the State POC.</p>
				</div>
			</div>

			<div class="form-half">
				<label class="light-font" id="ethnicity">10.a. Ethnicity</label>
				<label> Hispanic or Latino</label>
				<div class="control-group">
					<label class="radio dark-font">
						<input type="radio" v-model="form_data.ethnicity" value="hispanic" :disabled="formDisabled">
						<span><i class="fas fa-check-circle"></i>Yes</span>
					</label>
					<label class="radio dark-font">
						<input type="radio" v-model="form_data.ethnicity" value="nonhispanic" :disabled="formDisabled">
						<span><i class="fas fa-check-circle"></i>No</span>
					</label>
				</div>
			</div>

			<div class="form-full">
				<label class="light-font" id="race">10.b. Race (In addition to ethnicity, select one or more race in 10.b. Both 10.a. and 10.b. must be answered.)</label>
				<div id="race">
					<label class="dark-font checkbox">
						<input type="checkbox" v-model="form_data.customerRace.l4" :disabled="formDisabled">
						<span>
							<i class="fas fa-check-circle"></i>
							American Indian or Alaskan Native
						</span>
					</label>

					<label class="dark-font checkbox">
						<input type="checkbox" v-model="form_data.customerRace.l2" :disabled="formDisabled">
						<span>
							<i class="fas fa-check-circle"></i>
							Black or African American
						</span>
					</label>

					<label class="dark-font checkbox">
						<input type="checkbox" v-model="form_data.customerRace.l6" :disabled="formDisabled">
						<span><i class="fas fa-check-circle"></i>White</span>
					</label>

					<label class="dark-font checkbox">
						<input type="checkbox" v-model="form_data.customerRace.l1" :disabled="formDisabled">
						<span><i class="fas fa-check-circle"></i>Asian</span>
					</label>

					<label class="dark-font checkbox">
						<input type="checkbox" v-model="form_data.customerRace.l5" :disabled="formDisabled">
						<span>
							<i class="fas fa-check-circle"></i>
							Native Hawaiian or Other Pacific Islander
						</span>
					</label>
				</div>
			</div>

			<div class="help-box-outer form-full">
				<div :class="['help-box-label', showHelp.indexOf(4) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(4)">Instructions</div>
				<div class="help-box" v-show="showHelp.indexOf(4) > -1">
					<p>Question 10.a. and 10.b. Federal regulations (27 CFR 478.124(c)(1)) require licensees to obtain the race of the transferee/buyer. This information helps the FBI and/or State POC make or rule out potential matches during the background check process and can assist with criminal investigations. Pursuant to Office of Management and Budget (OMB), effective January 1, 2003, all Federal agencies requiring collection of race and ethnicity information on administrative forms and records, were required to collect this information in a standard format. (See 62 FR 58782) The standard OMB format consists of two categories for data on ethnicity: "Hispanic or Latino," and "Not Hispanic or Latino" and five categories for data on race: American Indian or Alaska Native, Asian, Black or African American, Native Hawaiian or Other Pacific Islander, and White.</p>
					<p>Ethnicity refers to a person's heritage. Persons of Cuban, Mexican, Puerto Rican, South or Central American, or other Spanish culture or origin, regardless of race, are considered Hipic or Latino.</p>
					<p>Race - one or more of the following responses must be selected: (1) American Indian or Alaska Native - A person having origins in any of the original peoples of North and South America (including Central America), and who maintains a tribal affiliation or community attachment; (2) Asian - A person having origins in any of the original peoples of the Far East, Southeast Asia, or the Indian subcontinent including, for example, Cambodia, China, India, Japan, Korea, Malaysia, Pakistan, the Philippine Islands, Thailand, and Vietnam; (3) Black or African American - A person having origins in any of the Black racial groups of Africa; (4) Native Hawaiian or Other Pacific Islander - A person having origins in any of the original peoples of Hawaii, Guam, Samoa, or other Pacific Islands; and (5) White - A person having origins in any of the original peoples of Europe, the Middle East, or North Africa. Any other race or ethnicity that does not fall within those indicated, please select the closest representation.</p>
				</div>
			</div>

			<div class="form-full">
				<p class="light-font">11. Answer each of the following questions by checking or marking "yes" or "no".</p>
			</div>

			<div class="form-threequarter">
				<label id="actual_buyer" class="dark-font">a. Are you the actual transferee/buyer of the firearm(s) listed on this form? Warning: You are not the actual transferee/buyer if you are acquiring the firearm(s) on behalf of another person. If you are not the actual transferee/buyer, the licensee cannot transfer the firearm(s) to you. Exception: If you are picking up a repaired firearm(s) for another person, you are not required to answer 11.a. and may proceed to question 11.b.</label>
			</div>

			<div class="form-quarter control-group" id="actual_buyer">
				<label class="radio">
					<input type="radio" v-model="form_data.actual_buyer" value="yes" :disabled="formDisabled">
					<span><i class="fas fa-check-circle"></i>Yes</span>
				</label>
				<label class="radio">
					<input type="radio" v-model="form_data.actual_buyer" value="no" :disabled="formDisabled">
					<span><i class="fas fa-check-circle"></i>No</span>
				</label>
			</div>

			<div class="help-box-outer form-full">
				<div :class="['help-box-label', showHelp.indexOf(5) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(5)">Instructions</div>
				<div class="help-box" v-show="showHelp.indexOf(5) > -1">
					<p>Question 11.a. Actual Transferee/Buyer: For purposes of this form, a person is the actual transferee/buyer if he/she is purchasing the firearm for him/herself or otherwise acquiring the firearm for him/herself. (e.g., redeeming the firearm from pawn, retrieving it from consignment, firearm raffle winner). A person is also the actual transferee/buyer if he/she is legitimately purchasing the firearm as a bona fide gift for a third party. A gift is not bona fide if another person offered or gave the person completing this form money, service(s), or item(s) of value to acquire the firearm for him/her, or if the other person is prohibited by law from receiving or possessing the firearm.</p>
					<p>Actual TRANSFEREE/buyer examples: Mr. Smith asks Mr. Jones to purchase a firearm for Mr. Smith (who may or may not be prohibited). Mr. Smith gives Mr. Jones the money for the firearm. Mr. Jones is NOT THE ACTUAL TRANSFEREE/BUYER of the firearm and must answer "NO" to question 11.a. The licensee may not transfer the firearm to Mr. Jones. However, if Mr. Brown buys the firearm with his own money to give to Mr. Black as a gift (with no service or tangible thing of value provided by Mr. Black), Mr. Brown is the actual transferee/buyer of the firearm and should answer "YES" to question 11.a. However, the transferor/seller may not transfer a firearm to any person he/she knows or has reasonable cause to believe is prohibited under 18 U.S.C. 922(g), (n) or (x). EXCEPTION: If a person is picking up a repaired firearm(s) for another person, he/she is not required to answer 11.a. and may proceed to question 11.b.</p>
				</div>
			</div>

			<div class="form-threequarter">
				<label id="under_indictment" class="dark-font">b. Are you under indictment or information in any court for a felony, or any other crime for which the judge could imprison you for more than one year?</label>
			</div>

			<div class="form-quarter control-group" id="under_indictment">
				<label class="radio">
					<input type="radio" v-model="form_data.under_indictment" value="yes" :disabled="formDisabled">
					<span><i class="fas fa-check-circle"></i>Yes</span>
				</label>
				<label class="radio">
					<input type="radio" v-model="form_data.under_indictment" value="no" :disabled="formDisabled">
					<span><i class="fas fa-check-circle"></i>No</span>
				</label>
			</div>

			<div class="help-box-outer form-full">
				<div :class="['help-box-label', showHelp.indexOf(6) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(6)">Instructions</div>
				<div class="help-box" v-show="showHelp.indexOf(6) > -1">
					<p>Question 11.b. - 12. Generally, 18 U.S.C. 922(g) prohibits the shipment, transportation, receipt, or possession in or affecting interstate commerce of a firearm by one who: has been convicted of a felony in any Federal, State or local court, or any other crime, punishable by imprisonment for a term exceeding one year (this does not include State misdemeanors punishable by imprisonment of two years or less); is a fugitive from justice; is an unlawful user of, or addicted to, marijuana or any depressant, stimulant, or narcotic drug, or any other controlled substance; has been adjudicated as a mental defective or has been committed to a mental institution; has been discharged from the Armed Forces under dishonorable conditions; is subject to certain restraining orders; convicted of a misdemeanor crime of domestic violence under Federal, State or Tribal law; has renounced his/her U.S. citizenship; is an alien illegally in the United States or an alien admitted to the United States under a nonimmigrant visa. Furthermore, section 922(n) prohibits the shipment, transportation, or receipt in or affecting interstate commerce of a firearm by one who is under indictment or information for a felony in any Federal, State or local court, or any other crime, punishable by imprisonment for a term exceeding one year. An information is a formal accusation of a crime verified by a prosecutor.</p>
					<p>A member of the Armed Forces must answer "yes" to 11.b. or 11.c. if charged with an offense that was either referred to a General Court Martial, or at which the member was convicted. Discharged "under dishonorable conditions" means separation from the Armed Forces resulting from a dishonorable discharge or dismissal adjudged by a General Court-Martial. That term does not include any other discharge or separation from the Armed Forces.</p>
					<p>EXCEPTION: A person who has been convicted of a felony, or any other crime, for which the judge could have imprisoned the person for more than one year, or who has been convicted of a misdemeanor crime of domestic violence, is not prohibited from purchasing, receiving, or possessing a firearm if: (1) under the law of the jurisdiction where the conviction occurred, the person has been pardoned, the conviction has been expunged or set aside, or the person has had their civil rights (the right to vote, sit on a jury, and hold public office) taken away and later restored, AND (2) the person is not prohibited by the law of the jurisdiction where the conviction occurred from receiving or possessing firearms. Persons subject to this exception, or who receive relief from disabilities under 18 U.S.C. 925(c), should answer "no" to the applicable question.</p>
				</div>
			</div>

			<div class="form-threequarter">
				<label id="convict" class="dark-font">c. Have you ever been convicted in any court of a felony, or any other crime for which the judge could have imprisoned you for more than one year, even if you received a shorter sentence including probation?</label>
			</div>

			<div class="form-quarter control-group" id="convict">
				<label class="radio">
					<input type="radio" v-model="form_data.convict" value="yes" :disabled="formDisabled">
					<span><i class="fas fa-check-circle"></i>Yes</span>
				</label>
				<label class="radio">
					<input type="radio" v-model="form_data.convict" value="no" :disabled="formDisabled">
					<span><i class="fas fa-check-circle"></i>No</span>
				</label>
			</div>

			<div class="form-threequarter">
				<label id="fugitive" class="dark-font">d. Are you a fugitive from justice?</label>
			</div>

			<div class="form-quarter control-group" id="fugitive">
				<label class="radio">
					<input type="radio" v-model="form_data.fugitive" value="yes" :disabled="formDisabled">
					<span><i class="fas fa-check-circle"></i>Yes</span>
				</label>
				<label class="radio">
					<input type="radio" v-model="form_data.fugitive" value="no" :disabled="formDisabled">
					<span><i class="fas fa-check-circle"></i>No</span>
				</label>
			</div>

			<div class="form-threequarter">
				<label id="addict" class="dark-font">e. Are you an unlawful user of, or addicted to, marajuana or any depressant, stimulant, narcotic drug, or any other controlled substance? <i>Warning: The use or possession of marajuana remains unlawful under Federal law regardless of whether it has been legalized or decriminalized for medicinal or recreational purposes in the state where you reside.</i></label>
			</div>

			<div class="form-quarter control-group" id="addict">
				<label class="radio">
					<input type="radio" v-model="form_data.addict" value="yes" :disabled="formDisabled">
					<span><i class="fas fa-check-circle"></i>Yes</span>
				</label>
				<label class="radio">
					<input type="radio" v-model="form_data.addict" value="no" :disabled="formDisabled">
					<span><i class="fas fa-check-circle"></i>No</span>
				</label>
			</div>

			<div class="help-box-outer form-full">
				<div :class="['help-box-label', showHelp.indexOf(7) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(7)">Instructions</div>
				<div class="help-box" v-show="showHelp.indexOf(7) > -1">
					<p>Question 11.d. Fugitive from Justice: Any person who has fled from any State to avoid prosecution for a felony or a misdemeanor; or any person who leaves the State to avoid giving testimony in any criminal proceeding. The term also includes any person who knows that misdemeanor or felony charges are pending against such person and who leaves the State of prosecution.</p>
				</div>
			</div>

			<div class="form-threequarter">
				<label id="mental" class="dark-font">f. Have you ever been adjudicated as a mental defective OR have you ever been committed to a mental institution?</label>
			</div>

			<div class="form-quarter control-group" id="mental">
				<label class="radio">
					<input type="radio" v-model="form_data.mental" value="yes" :disabled="formDisabled">
					<span><i class="fas fa-check-circle"></i>Yes</span>
				</label>
				<label class="radio">
					<input type="radio" v-model="form_data.mental" value="no" :disabled="formDisabled">
					<span><i class="fas fa-check-circle"></i>No</span>
				</label>
			</div>

			<div class="help-box-outer form-full">
				<div :class="['help-box-label', showHelp.indexOf(8) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(8)">Instructions</div>
				<div class="help-box" v-show="showHelp.indexOf(8) > -1">
					<p>Question 11.f. Adjudicated as a Mental Defective: A determination by a court, board, commission, or other lawful authority that a person, as a result of marked subnormal intelligence, or mental illness, incompetency, condition, or disease: (1) is a danger to himself or to others; or (2) lacks the mental capacity to contract or manage his own affairs. This term shall include: (1) a finding of insanity by a court in a criminal case; and (2) those persons found incompetent to stand trial or found not guilty by reason of lack of mental responsibility.</p>
					<p>Committed to a Mental Institution: A formal commitment of a person to a mental institution by a court, board, commission, or other lawful authority. The term includes a commitment to a mental institution involuntarily. The term includes commitment for mental defectiveness or mental illness. It also includes commitments for other reasons, such as for drug use. The term does not include a person in a mental institution for observation or a voluntary admission to a mental institution.</p>
					<p>EXCEPTION: Under the NICS Improvement Amendments Act of 2007, a person who has been adjudicated as a mental defective or committed to a mental institution in a State proceeding is not prohibited by the adjudication or commitment if the person has been granted relief by the adjudicating/committing State pursuant to a qualifying mental health relief from disabilities program. Also, a person who has been adjudicated as a mental defective or committed to a mental institution by a department or agency of Federal Government is not prohibited by the adjudication or commitment if either: (a) the person's adjudication or commitment was set-aside or expunged by the adjudicating/committing agency; (b) the person has been fully released or discharged from all mandatory treatment, supervision, or monitoring by the agency; (c) the person was found by the agency to no longer suffer from the mental health condition that served as the basis of the initial adjudication/ commitment; or (d) the adjudication or commitment, respectively, is based solely on a medical finding of disability, without an opportunity for a hearing by a court, board, commission, or other lawful authority, and the person has not been adjudicated as a mental defective consistent with section 922(g)(4) of title 18, United States Code; (e) the person was granted relief from the adjudicating/ committing agency pursuant to a qualified mental health relief from disabilities program. Persons who fall within one of the above exceptions should answer "no" to question 11.f. This exception to an adjudication or commitment by a Federal department or agency does not apply to any person who was adjudicated to be not guilty by reason of insanity, or based on lack of mental responsibility, or found incompetent to stand trial, in any criminal case or under the Uniform Code of Military Justice.</p>
				</div>
			</div>

			<div class="form-threequarter">
				<label id="dishonorable_discharge" class="dark-font">g. Have you been discharged from the Armed Forces under <i>dishonorable</i> conditions?</label>
			</div>

			<div class="form-quarter control-group" id="dishonorable_discharge">
				<label class="radio">
					<input type="radio" v-model="form_data.dishonorable_discharge" value="yes" :disabled="formDisabled">
					<span><i class="fas fa-check-circle"></i>Yes</span>
				</label>
				<label class="radio">
					<input type="radio" v-model="form_data.dishonorable_discharge" value="no" :disabled="formDisabled">
					<span><i class="fas fa-check-circle"></i>No</span>
				</label>
			</div>

			<div class="form-threequarter">
				<label id="restraining_order" class="dark-font">h. Are you subject to a court order restraining you from harassing, stalking, or threatening your child or an intimate partner or child of such partner?</label>
			</div>

			<div class="form-quarter control-group" id="restraining_order">
				<label class="radio">
					<input type="radio" v-model="form_data.restraining_order" value="yes" :disabled="formDisabled">
					<span><i class="fas fa-check-circle"></i>Yes</span>
				</label>
				<label class="radio">
					<input type="radio" v-model="form_data.restraining_order" value="no" :disabled="formDisabled">
					<span><i class="fas fa-check-circle"></i>No</span>
				</label>
			</div>

			<div class="help-box-outer form-full">
				<div :class="['help-box-label', showHelp.indexOf(9) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(9)">Instructions</div>
				<div class="help-box" v-show="showHelp.indexOf(9) > -1">
					<p>Question 11.h. Qualifying Restraining Orders: Under 18 U.S.C. 922, firearms may not be sold to or received by persons subject to a court order that: (A) was issued after a hearing which the person received actual notice of and had an opportunity to participate in; (B) restrains such person from harassing, stalking, or threatening an intimate partner or child of such intimate partner or person, or engaging in other conduct that would place an intimate partner in reasonable fear of bodily injury to the partner or child; and (C)(i) includes a finding that such person represents a credible threat to the physical safety of such intimate partner or child; or (ii) by its terms explicitly prohibits the use, attempted use, or threatened use of physical force against such intimate partner or child that would reasonably be expected to cause bodily injury. An "intimate partner" of a person is: the spouse or former spouse of the person, the parent of a child of the person, or an individual who cohabitates or has cohabitated with the person.</p>
				</div>
			</div>

			<div class="form-threequarter">
				<label id="domestic_violence" class="dark-font">i. Have you ever been convicted in any court of a misdemeanor crime of domestic violence?</label>
			</div>

			<div class="form-quarter control-group" id="domestic_violence">
				<label class="radio">
					<input type="radio" v-model="form_data.domestic_violence" value="yes" :disabled="formDisabled">
					<span><i class="fas fa-check-circle"></i>Yes</span>
				</label>
				<label class="radio">
					<input type="radio" v-model="form_data.domestic_violence" value="no" :disabled="formDisabled">
					<span><i class="fas fa-check-circle"></i>No</span>
				</label>
			</div>

			<div class="help-box-outer form-full">
				<div :class="['help-box-label', showHelp.indexOf(10) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(10)">Instructions</div>
				<div class="help-box" v-show="showHelp.indexOf(10) > -1">
					<p>Question 11.i. Misdemeanor Crime of Domestic Violence: A Federal, State, local, or tribal offense that is a misdemeanor under Federal, State, or tribal law and has, as an element, the use or attempted use of physical force, or the threatened use of a deadly weapon, committed by a current or former spouse, parent, or guardian of the victim, by a person with whom the victim shares a child in common, by a person who is cohabitating with, or has cohabited with the victim as a spouse, parent, or guardian, or by a person similarly situated to a spouse, parent, or guardian of the victim. The term includes all misdemeanors that have as an element the use or attempted use of physical force or the threatened use of a deadly weapon (e.g., assault and battery), if the offense is committed by one of the defined parties. (See Exception to 11.b. - 12.) A person who has been convicted of a misdemeanor crime of domestic violence also is not prohibited unless: (1) the person was represented by a lawyer or gave up the right to a lawyer; or (2) if the person was entitled to a jury, was tried by a jury, or gave up the right to a jury trial. Persons subject to this exception should answer "no" to 11.i.</p>
				</div>
			</div>

			<div class="form-quarter control-group">
				<label id="origin_country" class="light-font">12.a. Country of Citizenship (Check/List more than one, if applicable. Nations of the United States may check U.S.A.)</label>
			</div>

			<div class="form-threequarter">
				<div id="origin_country">
					<label class="dark-font usa-label radio">
						<input type="radio" v-model="form_data.customerValues.CITIZEN_STATUS_CODE" value="C" id="usa" :disabled="formDisabled">
						<span>
							<i class="fas fa-check-circle"></i>
							United States of America (U.S.A.)
						</span>
					</label>
					<label class="dark-font other-label radio">
						<input type="radio" v-model="form_data.customerValues.CITIZEN_STATUS_CODE" value="F" id="other" :disabled="formDisabled">
						<span>
							<i class="fas fa-check-circle"></i>
							Other Country/Countries (Specify):
						</span>
					</label>
					<template v-if="form_data.customerValues.CITIZEN_STATUS_CODE == 'F'">
						<select v-model="form_data.customerValues.CITIZEN_COUNTRY_CODE" :disabled="formDisabled">
						    <option value>Country...</option>
						    <option v-for="(country, code) in this.COUNTRIES_LIST" :value="code">{{ country }}</option>
						</select>
						<select v-model="form_data.customerValues.CITIZEN_COUNTRY_CODE_2" v-if="form_data.customerValues.CITIZEN_COUNTRY_CODE" :disabled="formDisabled">
						    <option value>Country...</option>
						    <option v-for="(country, code) in this.COUNTRIES_LIST" :value="code">{{ country }}</option>
						</select>
						<select v-model="form_data.customerValues.CITIZEN_COUNTRY_CODE_3" v-if="form_data.customerValues.CITIZEN_COUNTRY_CODE && form_data.customerValues.CITIZEN_COUNTRY_CODE_2" :disabled="formDisabled">
						    <option value>Country...</option>
						    <option v-for="(country, code) in this.COUNTRIES_LIST" :value="code">{{ country }}</option>
						</select>
					</template>
				</div>
			</div>

			<div class="form-threequarter">
				<label id="renounced_citizenship" class="dark-font">12.b. Have you ever renounced your United States citizenship?</label>
			</div>

			<div class="form-quarter control-group" id="renounced_citizenship">
				<label class="radio">
					<input type="radio" v-model="form_data.renounced_citizenship" value="yes" :disabled="formDisabled">
					<span><i class="fas fa-check-circle"></i>Yes</span>
				</label>
				<label class="radio">
					<input type="radio" v-model="form_data.renounced_citizenship" value="no" :disabled="formDisabled">
					<span><i class="fas fa-check-circle"></i>No</span>
				</label>
			</div>

			<div class="form-threequarter">
				<label id="illegal_alien" class="dark-font">12.c. Are you an alien <i>illegally</i> or <i>unlawfully</i> in the United States?</label>
			</div>

			<div class="form-quarter control-group" id="illegal_alien">
				<label class="radio">
					<input type="radio" v-model="form_data.illegal_alien" value="yes" :disabled="formDisabled">
					<span><i class="fas fa-check-circle"></i>Yes</span>
				</label>
				<label class="radio">
					<input type="radio" v-model="form_data.illegal_alien" value="no" :disabled="formDisabled">
					<span><i class="fas fa-check-circle"></i>No</span>
				</label>
			</div>

			<div class="form-threequarter">
				<label id="legal_alien" class="dark-font">12.d.1. Are you an alien who has been admitted to the United States under a nonimmigrant visa?</label>
			</div>

			<div class="form-quarter control-group" id="legal_alien">
				<label class="radio">
					<input type="radio" v-model="form_data.legal_alien" value="yes" :disabled="formDisabled">
					<span><i class="fas fa-check-circle"></i>Yes</span>
				</label>
				<label class="radio">
					<input type="radio" v-model="form_data.legal_alien" value="no" :disabled="formDisabled">
					<span><i class="fas fa-check-circle"></i>No</span>
				</label>
			</div>

			<div class="help-box-outer form-full">
				<div :class="['help-box-label', showHelp.indexOf(11) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(11)">Instructions</div>
				<div class="help-box" v-show="showHelp.indexOf(11) > -1">
					<p>Question 12.d. Immigration Status: An alien admitted to the United States under a nonimmigrant visa includes, among others, persons visiting the United States temporarily for business or pleasure, persons studying in the United States who maintain a residence abroad, and certain temporary foreign workers. These aliens must answer "yes" to this question and provide the additional documentation required under question 18.c. Permanent resident aliens and aliens legally admitted to the United States pursuant to either the Visa Waiver Program or to regulations otherwise exempting them from visa requirements may answer "no" to this question and are not required to submit the additional documentation under question 18.c.</p>
				</div>
			</div>

			<div class="form-threequarter">
				<label class="dark-font" id="exc_code">12.d.2. If "yes", do you fall within any of the exceptions stated in the instructions?</label>
			</div>

			<div class="form-quarter control-group">
				<label class="radio">
					<input type="radio" v-model="form_data.customerValues.EXC_CODE" value="Y" :disabled="formDisabled">
					<span><i class="fas fa-check-circle"></i>Yes</span>
				</label>
				<label class="radio">
					<input type="radio" v-model="form_data.customerValues.EXC_CODE" value="N" :disabled="formDisabled">
					<span><i class="fas fa-check-circle"></i>No</span>
				</label>
				<label class="radio">
					<input type="radio" v-model="form_data.customerValues.EXC_CODE" value="X" :disabled="formDisabled">
					<span><i class="fas fa-check-circle"></i>N/A</span>
				</label>
			</div>

			<div class="form-full">
				<label class="dark-font" id="MNU1">13. If you are an alien, record your U.S.-Issued Alien or Admission Number (AR#, USCIS#, OR I94#)</label>
				<input type="text" v-model="form_data.customerValues.MNU1" :disabled="formDisabled">
			</div>

			<div class="help-box-outer form-full">
				<div :class="['help-box-label', showHelp.indexOf(12) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(12)">Instructions</div>
				<div class="help-box" v-show="showHelp.indexOf(12) > -1">
					<p>Question 13. U.S.-issued Alien Number or Admission Number: U.S.-issued alien and admission numbers may be found on the following U.S. Department of Homeland Security documents: Legal Resident Card or Employment Authorization Card (AR# or USCIS#); Arrival/Departure Record, Form I94, or Form 797A (I94#). Additional information can be obtained from www.cbp.gov. If you are a U.S. citizen or U.S. national then this question should be left blank.</p>
				</div>
			</div>

			<div class="form-full">
				<input type="checkbox" v-model="form_data.i_certify" :disabled="formDisabled">
				<label class="light-font agreement" id="i_certify">I certify that my answers in Section A are true, correct, and complete. I have read and understand the Notices, Instructions, and Definitions on ATF Form 4473. I understand that answering "yes" to question 11.a. if I am not the actual transferee/buyer is a crime punishable as a felony under Federal law, and may also violate State and/or local law. I understand that a person who answers "yes" to any of the questions 11.b. through 11.i and/or 12.b. through 12.c. is prohibited from purchasing or receiving a firearm. I understand that a person who answers "yes" to question 12.d. is prohibited from receiving or possessing a firearm, unless the person answers "yes" to question 12.d.2. and provides the documentation required in 18.c. I also understand that making any false oral or written statement, or exhibiting any false or misinterpreted identification with respect to this transaction, is a crime punishable as a felony under Federal law, and may also violate State and/or local law. I further understand that the repetitive purchase of firearms for the purpose of resale for livelihood and profit without a Federal firearms license is a violation of Federal law.</label>
			</div>

			<div class="form-threequarter">
				<label class="light-font" id="signature">14. Transferee's/Buyer's Signature</label>
				<canvas id="signature_pad" width="800" height="213" v-if="!form_data.signature && formOption != 'existing'"></canvas>
				<div class="signature-group" v-else>
					<img class="signature" :src="form_data.signature">
					<div class="cancel-signature" @click="cancelSignature()"><i class="fas fa-times"></i></div>
				</div>
			</div>

			<div class="form-quarter signature">
				<label class="light-font" id="signed_date">15. Date</label>
				<input v-if="formOption == 'existing'" :class="{ disabled: formDisabled }" :disabled="formDisabled" type="date" v-model="form_data.signed_date">
				<input v-else :class="{ disabled: formDisabled, error: signedDateError }" :disabled="formDisabled" type="date" v-model="form_data.signed_date">
				<div class="tooltip" v-if="!formDisabled && signedDateError">Please enter today's date</div>
			</div>

			<div class="help-box-outer form-full">
				<div :class="['help-box-label', showHelp.indexOf(13) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(13)">Instructions</div>
				<div class="help-box" v-show="showHelp.indexOf(13) > -1">
					<p>Question 14. Under 18 U.S.C. 922(a)(1), it is unlawful for a person to engage in the business of dealing in firearms without a license. A person is engaged in the business of dealing in firearms if he/she devotes time, attention, and labor to dealing in firearms as a regular course of trade or business with the principal</p>
				</div>
			</div>

			<template v-if="formDisabled">
				<h2 class="form-full section-title">Section C - Must Be Completed Personally By Transferee/Buyer</h2>
				<div class="form-full">If the transfer of the firearm(s) takes place on a different day from the date that the transferee/buyer signed Section A, the transferee/buyer must complete Section C immediately prior to the transfer of the firearm(s). (See Instructions for Question 22 and 23.)</div>

				<div class="form-full dark-font">I certify that my answers to the questions in Section A of this form are still true, correct, and complete.</div>

				<div class="form-threequarter light-font"><label class="light-font">22. Transferee's/Buyer's Signature</label>
					<!-- <div class="signature-group">
						<img class="signature" :src="section_c.buyer_recertification_signature">
						<div class="cancel-signature" @click="cancelSignature()"><i class="fas fa-times"></i></div>
					</div> -->

					<canvas id="signature_pad_section_c" width="800" height="213" v-if="!section_c.buyer_recertification_signature"></canvas>
					<div class="signature-group" v-else>
						<img class="signature" :src="section_c.buyer_recertification_signature">
						<div class="cancel-signature" @click="cancelSignature()"><i class="fas fa-times"></i></div>
					</div>

				</div>
				<div class="form-quarter light-font signature">
					<label class="light-font">23. Recertification Date</label>
					<input type="date" :class="{ error: buyerRecertificationDateError }" v-model="section_c.buyer_recertification_date" v-if="formOption == 'existing'"> <!--  :min="today" :max="today" -->
					<input class="disabled" disabled type="date" v-model="section_c.buyer_recertification_date" v-else>
					<div class="tooltip" v-if="buyerRecertificationDateError">Please select today's date</div>
				</div>

				<div class="help-box-outer form-full">
					<div :class="['help-box-label', showHelp.indexOf(14) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(14)">Instructions</div>
					<div class="help-box" v-show="showHelp.indexOf(14) > -1">
						Questions 22 and 23. Transfer on a Different Day and Recertification: If the transfer takes place on a different day from the date that the transferee/buyer signed Section A, the licensee must again check the photo identification of the transferee/buyer at the time of transfer.
					</div>
				</div>
			</template>

			<button class="button action" @click.stop="validateForm" v-if="!formDisabled">Submit</button>
			<button class="button action" @click.stop="sendForm" v-else>Submit</button>
			<span class="loading" v-if="loading"><i class="fas fa-spinner fa-spin"></i></span>
			<span class="message" v-if="message">{{ message }}</span>

		</div>

	</div><!-- v-if="formIncomplete" -->

	<div class="form-complete" v-else v-cloak>
		<h1>Your completed 4473 has been saved!</h1>
		<button class="button action" @click="resetForm">OK</button>
		<!-- <a class="button action" :href="generatePDFLink()" target="_blank">Print Form</a> -->
		<!--<a @click="goToDealerVersion">Go to dealer version</a>-->
	</div>
</div>

</template>

<script>
export default {
	name: 'customer-form-4473',
	data() {
		return {
			apiEndpoint: null,
			printing: false,
			username: null,
    		password: null,
    		loading: false,
    		formId: null,
    		order_number: null,
    		disposals: [],
    		forms: [],
    		search_disposals: null,
    		search_forms: null,
    		disposalSearchMessage: null,
    		formSearchMessage: null,
    		formOption: null,
    		extraAddress: false,
			user: {
				user_id: null,
				user_name: null,
				user_type_code: null
			},
			client: {
				company_name: null,
			},
			client_logo_src: null,
			contact: {
				contact_id: null,
				client_id: null,
				first_name: null,
				middle_name: null,
				last_name: null,
				suffix: null,
				address_1: null,
				city: null,
				state: null,
				zip_code: null,
				birthdate: null
			},
			form_data: {
				county: null,
				first_initial: '',
				middle_initial: '',
				last_initial: '',
				middle_name_blank: false,
				extra_address_1: null,
				extra_city: null,
				extra_county: null,
				extra_state: null,
				extra_zip_code: null,
				birth_city: null,
				foreign_country: null,
				other_country: null,
				feet: null,
				inches: null,
				ethnicity: null,
				customerValues: {
					POB_CODE: null,
					CITIZEN_STATUS_CODE: null,
					CITIZEN_COUNTRY_CODE: null,
					CITIZEN_COUNTRY_CODE_2: null,
					CITIZEN_COUNTRY_CODE_3: null,
					HEIGHT: null,
					WEIGHT: null,
					GENDER_CODE: null,
					SSN: null,
					UPIN: null,
					EXC_CODE: null,
					MNU1: null,
					MNU_TYPE_CODE1: null
				},
				customerRace: {
					l1: false,
					l2: false,
					l4: false,
					l5: false,
					l6: false
				},
				origin_country: null,
				actual_buyer: '',
				under_indictment: null,
				convict: null,
				fugitive: null,
				addict: null,
				mental: null,
				dishonorable_discharge: null,
				restraining_order: null,
				domestic_violence: null,
				renounced_citizenship: null,
				illegal_alien: null,
				legal_alien: null,
				i_certify: null,
				signature: null,
				signed_date: null,
			},
			section_c: {
				buyer_recertification_signature: null,
				buyer_recertification_date: null
			},
			message: '',
			signaturePad: null,
			scriptel: null,
			birthdate: null,
			signed_date: null,
			signedDateError: false,
			buyerRecertificationDateError: false,
			showHelp: [],
			states: this.STATES_LIST,
			countries: this.COUNTRIES_LIST,
            formIncomplete: true,
			captureBuyerRecertificationSignature: false,
			captureSignature: false
		}
	},
	created() {
		this.apiCallLocal('logout')
	},
	watch: {
		'form_data.middle_name_blank': function(data) {
			if (data === true) {
				this.toggleInitial('contact', 'middle_name', data)
				this.toggleInitial('form_data', 'middle_initial', data)
			}
		},
		'form_data.customerValues.CITIZEN_STATUS_CODE': function(data) {
			this.form_data.customerValues.CITIZEN_COUNTRY_CODE = (data == 'C') ? 'United States of America' : null
		},
		formOption(newVal) {
			if (newVal && !this.form_data.section_c) {
				setTimeout(() => {
					this.initializeSignaturePad()
				}, 2000)
			}
		},
		'form_data.signed_date'(newVal) {
			if (!this.$moment(newVal).isSame(this.today)) {
				this.signedDateError = true
			} else {
				this.signedDateError = false
			}
		},
		'section_c.buyer_recertification_date'(newVal) {
			if (!this.$moment(newVal).isSame(this.today)) {
				this.buyerRecertificationDateError = true
			} else {
				this.buyerRecertificationDateError = false
			}
		}
	},
	computed: {
		today() {
			return this.$moment().format('YYYY-MM-DD')
		},
		formDisabled() {
			if (this.formOption == 'new') {
				return false
			} else {
				return this.contact.section_completed != ''
			}
		}
	},
	methods: {
		apiCallLocal(action, data) {
			if (!this.apiEndpoint) {
				this.apiEndpoint = '//' + (document.location.hostname.indexOf('.test') > -1 ? 'cdsapi.test' : document.location.hostname + '/api') + '/api.php?action='
			}
			return new Promise((resolve, reject) => {
	            let headers = {
	                method: 'post',
	                body: JSON.stringify(data),
	                credentials: 'include'
	            }
	            fetch(this.apiEndpoint + action, headers).then(function(response) {
	                return response.json()
	            }).then(obj => {
                    resolve(obj)
	            }).catch(error => {
	                reject(error)
	            })
	        })
		},
		doLogin() {
    		if (!this.username || !this.password) return
		    this.message = ''
			this.loading = true
    		this.apiCallLocal('login', { user_name: this.username, password: this.password, source: 'LOGBOOKS' }).then(obj => {
				this.loading = false
    			if (obj.status == 'success') {
					this.user = obj.user
					this.fetchClient()
    			} else {
    				this.message = obj.message
    			}
    		})
    	},
    	doLogout() {
    		this.apiCallLocal('logout').then(obj => {
    			if (obj.status == 'success') {
    				window.location.reload()
    			}
    		})
    	},
		fetchClient() {
			// TO-DO: If we are on ffloffice.com, do we get the client back from login
			// or do we send something with the get_client request to identify the client? user_id?
			let data = {
				source: 'LOGBOOKS'
			}
			this.apiCallLocal('get_client', data).then(obj => {
				this.client = obj.client
				this.client_logo_src = this.client.logo_src || null
			}).catch(err => {
				console.log(err)
			})
		},
		searchDisposals() {
			if (!this.search_disposals) return
			this.disposals = null
			this.disposalSearchMessage = null
			this.apiCallLocal('get_list_disposals', { search_term: this.search_disposals, search_all_contacts: true, source: 'LOGBOOKS' }).then(obj => {
				if (obj.status == 'error') {
					this.disposalSearchMessage = obj.message
				} else if (obj.disposals.length > 0) {
					this.disposals = obj.disposals
				} else {
					this.disposalSearchMessage = 'No matching disposals found.'
				}
			})
		},
		assignDisposal(disposal) {
			// ATF requires customer to manaully enter all info
			// so we'll simply assign the contact_id, and upon submit we'll update the contact in the database
			// but go ahead and populate if in dev environment
			if (document.location.hostname.indexOf('.test') > -1) {
				for (var key in this.contact) {
				    if (!this.contact.hasOwnProperty(key)) continue
				    this.contact[key] = disposal[key]
				}
			}
			this.contact.contact_id = disposal.contact_id
			this.formOption = 'new'
		},
		searchForms() {
			if (!this.search_forms) return
			this.forms = []
			this.formSearchMessage = null
			this.apiCallLocal('get_list_ffl_log_book_forms', { search_term: this.search_forms, status: 'NICS_PROCEED,NICS_DELAYED,NICS_NO_RESPONSE', source: 'LOGBOOKS', context: 'CUSTOMER', version: 1 }).then(obj => {
				if (obj.status == 'error') {
					this.disposalSearchMessage = obj.message
				} else if (obj.log_book_forms.length > 0) {
					this.forms = obj.log_book_forms
				} else {
					this.formSearchMessage = "No matching eligible 4473s found."
				}
			}).catch(err => {
				console.log(err)
			})
		},
		assignForm(form) {
			this.contact = {
				contact_id: form.form_data.contact_id,
				first_name: form.form_data.first_name,
				middle_name: form.form_data.middle_name,
				last_name: form.form_data.last_name,
				address_1: form.form_data.address_1,
				address_2: form.form_data.address_2,
				city: form.form_data.city,
				state: form.form_data.state,
				zip_code: form.form_data.zip_code,
				birthdate: form.form_data.birthdate
			}
			this.formId = form.ffl_log_book_form_id
			this.form_data = form.form_data
			this.formOption = 'existing'
			this.message = null
			this.formIncomplete = true
		},
		fullName(contact) {
			if (!contact) return null
			if (contact.full_name) {
				return contact.full_name
			} else {
				return (contact.company_name) ? contact.company_name : contact.first_name + " " + contact.last_name
			}
		},
		initializeSignaturePad() {
			var prevPoint;

			if (this.formDisabled) {
				this.signaturePad = document.getElementById("signature_pad_section_c");
			} else {
				this.signaturePad = document.getElementById("signature_pad");
			}

			this.scriptel = new ScriptelEasyScript();

			this.scriptel.configurationCallback = (evt,chr) => {
				if(chr==='"') {
					this.scriptel.fromKeyboardSpec = "ca-fr";
				} else {
					this.scriptel.fromKeyboardSpec = "us-basic";
				}
			};

			this.scriptel.addSignatureListener(document);
			this.scriptel.registerStreamingCallback((e) => {
		        switch (e.type) {
		            case "ScriptelSignatureMetaData":
						this.clearCanvas();
		                break;
		            case "ScriptelNewStroke":
                		prevPoint = null;
		                break;
		            case "ScriptelCoordinate":
		            	if (prevPoint != null) {
							this.scriptel.drawSegmentOnCanvas(prevPoint, e, this.signaturePad,{"strokeStyle":"black","lineWidth":2});
						}
						prevPoint = e;
		                break;
		            case "ScriptelCancelSignature":
		            	this.clearCanvas();
		            	prevPoint = null;
		                break;
		            case "ScriptelSignatureComplete":
		            	this.saveSignature()
		                break;
		        }
			});
		},
		saveSignature() {
			if (!this.form_data.signature) {
		        this.form_data.signature = this.signaturePad.toDataURL()
		    } else {
		        this.section_c.buyer_recertification_signature = this.signaturePad.toDataURL()
		    }
		},
		clearCanvas() {
            //Get the graphics context of the canvas.
            var ctx = this.signaturePad.getContext("2d");
            //Clear the canvas and fill with the background color:
            ctx.clearRect(0,0,this.signaturePad.width,this.signaturePad.height);
        },
        cancelSignature() {
			if (this.formDisabled) {
				this.section_c.buyer_recertification_signature = null
			} else {
        		this.form_data.signature = null
			}
        	setTimeout(() => {
        		this.initializeSignaturePad()
        	}, 500)
        },
		newForm() {
			this.formOption = 'new'
			this.initializeSignaturePad()
		},
		doFormNew() {
			this.formOption = 'new'
			this.formIncomplete = true
		},
		logOut() {
			this.apiCallLocal('logout').then(obj => {
				location.reload()
			}).catch(err => {
				console.log(err)
			})
		},
		updateState(state) {
			this.contact.state = state
		},
		updateBirthplace(state) {
			this.form_data.customerValues.POB_CODE = state
		},
		validateForm() {
			// explicit checks allow us to keep validation in order of display fields
			if (!this.contact.first_name) {
				this.scroll('first_name')
				return false
			} else {
				this.removeError('first_name')
			}
			if (!this.contact.middle_name && !this.form_data.middle_name_blank) {
				this.scroll('middle_name')
				return false
			} else {
				this.removeError('middle_name')
			}
			if (!this.contact.last_name) {
				this.scroll('last_name')
				return false
			} else {
				this.removeError('last_name')
			}
			if (!this.contact.address_1) {
				this.scroll('address_1')
				return false
			} else {
				this.removeError('address_1')
			}
			if (!this.contact.city) {
				this.scroll('city')
				return false
			} else {
				this.removeError('city')
			}
			if (!this.form_data.county) {
				this.scroll('county')
				return false
			} else {
				this.removeError('county')
			}
			if (!this.contact.state) {
				this.scroll('state')
				return false
			} else {
				this.removeError('state')
			}
			if (!this.contact.zip_code) {
				this.scroll('zip_code')
				return false
			} else {
				this.removeError('zip_code')
			}
			if (!this.form_data.birth_city && !this.form_data.foreign_country) {
				this.scroll('place_of_birth')
				return false
			} else {
				this.removeError('place_of_birth')
			}
			if (!this.form_data.customerValues.POB_CODE && !this.form_data.foreign_country) {
				this.scroll('place_of_birth_state')
				return false
			} else {
				this.removeError('place_of_birth_state')
			}
			if (!this.form_data.feet) {
				this.scroll('feet')
				return false
			} else {
				this.removeError('feet')
			}
			if (!this.form_data.inches) {
				this.scroll('inches')
				return false
			} else {
				this.removeError('inches')
			}
			if (!this.form_data.customerValues.WEIGHT) {
				this.scroll('weight')
				return false
			} else {
				this.removeError('weight')
			}
			if (!this.form_data.customerValues.GENDER_CODE) {
				this.scroll('sex')
				return false
			} else {
				this.removeError('sex')
			}
			if (!this.contact.birthdate) {
				this.scroll('birthdate')
				return false
			} else {
				this.removeError('birthdate')
			}
			if (!this.form_data.ethnicity) {
				this.scroll('ethnicity')
				return false
			} else {
				this.removeError('ethnicity')
			}
			let raceIsComplete = []
			for (var key in this.form_data.customerRace) {
				if (!this.form_data.customerRace.hasOwnProperty(key)) continue
				if (this.form_data.customerRace[key]) raceIsComplete.push(key)
			}
			if (raceIsComplete.length == 0) {
				this.scroll('race')
				return false
			} else {
				this.removeError('race')
			}
			if (!this.form_data.actual_buyer) {
				this.scroll('actual_buyer')
				return false
			} else {
				this.removeError('actual_buyer')
			}
			if (!this.form_data.under_indictment) {
				this.scroll('under_indictment')
				return false
			} else {
				this.removeError('under_indictment')
			}
			if (!this.form_data.convict) {
				this.scroll('convict')
				return false
			} else {
				this.removeError('convict')
			}
			if (!this.form_data.fugitive) {
				this.scroll('fugitive')
				return false
			} else {
				this.removeError('fugitive')
			}
			if (!this.form_data.addict) {
				this.scroll('addict')
				return false
			} else {
				this.removeError('addict')
			}
			if (!this.form_data.mental) {
				this.scroll('mental')
				return false
			} else {
				this.removeError('mental')
			}
			if (!this.form_data.dishonorable_discharge) {
				this.scroll('dishonorable_discharge')
				return false
			} else {
				this.removeError('dishonorable_discharge')
			}
			if (!this.form_data.restraining_order) {
				this.scroll('restraining_order')
				return false
			} else {
				this.removeError('restraining_order')
			}
			if (!this.form_data.domestic_violence) {
				this.scroll('domestic_violence')
				return false
			} else {
				this.removeError('domestic_violence')
			}
			// 12.a.
			if (!this.form_data.customerValues.CITIZEN_STATUS_CODE) {
				this.scroll('origin_country')
				return false
			} else {
				this.removeError('origin_country')
			}
			// 12a other option
			if (this.form_data.customerValues.CITIZEN_STATUS_CODE == 'F' && !this.form_data.customerValues.CITIZEN_COUNTRY_CODE) {
				this.scroll('origin_country')
				return false
			} else {
				this.removeError('origin_country')
			}
			if (this.form_data.customerValues.CITIZEN_STATUS_CODE == 'C') {
				this.form_data.customerValues.CITIZEN_COUNTRY_CODE = null
				this.form_data.customerValues.CITIZEN_COUNTRY_CODE_2 = null
				this.form_data.customerValues.CITIZEN_COUNTRY_CODE_3 = null
			} else {
				this.form_data.origin_country = this.COUNTRIES_LIST[this.form_data.customerValues.CITIZEN_COUNTRY_CODE]
				this.form_data.origin_country += (this.form_data.customerValues.CITIZEN_COUNTRY_CODE_2) ? ", " + this.COUNTRIES_LIST[this.form_data.customerValues.CITIZEN_COUNTRY_CODE_2] : ""
				this.form_data.origin_country += (this.form_data.customerValues.CITIZEN_COUNTRY_CODE_3) ? ", " + this.COUNTRIES_LIST[this.form_data.customerValues.CITIZEN_COUNTRY_CODE_3] : ""
			}
			if (!this.form_data.renounced_citizenship) {
				this.scroll('renounced_citizenship')
				return false
			} else {
				this.removeError('renounced_citizenship')
			}
			if (!this.form_data.illegal_alien) {
				this.scroll('illegal_alien')
				return false
			} else {
				this.removeError('illegal_alien')
			}
			if (!this.form_data.legal_alien) {
				this.scroll('legal_alien')
				return false
			} else {
				this.removeError('legal_alien')
			}
			if (this.form_data.legal_alien && !this.form_data.customerValues.EXC_CODE) {
				this.scroll('exc_code')
				return false
			} else {
				this.removeError('exc_code')
			}
			// 13
			if (this.form_data.customerValues.CITIZEN_STATUS_CODE == 'F' && !this.form_data.customerValues.MNU1) {
				this.scroll('MNU1')
				return false
			} else {
				this.removeError('MNU1')
			}
			if (!this.form_data.i_certify) {
				this.scroll('i_certify')
				return false
			} else {
				this.removeError('i_certify')
			}
			if (document.location.hostname.indexOf('.test') > -1) {
				console.log('dev environment, signature not required')
			} else {
				if (!this.form_data.signature) {
					this.scroll('signature')
					return false
				} else {
					this.removeError('signature')
				}
			}
			if (!this.form_data.signed_date) {
				this.scroll('signed_date')
				return false
			} else {
				this.removeError('signed_date')
			}

			// All good, so clean up data and send form!
			if (this.form_data.foreign_country && !this.form_data.birth_city) {
				this.form_data.customerValues.POB_CODE = this.form_data.foreign_country
			}
			if (this.form_data.feet && !this.form_data.inches) {
				this.form_data.inches = ""
			}
			this.form_data.customerValues.HEIGHT = this.form_data.feet.toString() + this.form_data.inches.toString().padStart(2, "0")
			this.form_data.customerValues.isHispanicOrLatinotrue = (this.form_data.ethnicity == "hispanic") ? true : null
			this.form_data.customerValues.isHispanicOrLatinofalse = (this.form_data.ethnicity == "nonhispanic") ? true : null
			this.form_data.customerValues.LAST_NAME = this.contact.last_name
			this.form_data.customerValues.LAST_NAME += (this.form_data.last_initial) ? " IO" : ""
			this.form_data.customerValues.FIRST_NAME = this.contact.first_name
			this.form_data.customerValues.FIRST_NAME += (this.form_data.first_initial) ? " IO" : ""
			this.form_data.customerValues.MIDDLE_NAME = (this.form_data.middle_name_blank) ? "MNM" : this.contact.middle_name
			this.form_data.customerValues.MIDDLE_NAME += (!this.form_data.middle_name_blank && this.form_data.middle_initial) ? " IO" : ""
			this.form_data.customerValues.STATE_CODE = this.contact.state
			this.form_data.customerValues.DOB = this.contact.birthdate

			this.sendForm()
		},
		sendForm() {
			this.loading = true
			if (!this.formDisabled) {
				let data = {
					order_number: this.order_number,
					contact: this.contact,
					form_data: this.form_data,
					source: 'LOGBOOKS',
					version: 1
				}
				// send to server
				this.apiCallLocal('save_4473', data).then(obj => {
					this.loading = false
					if (obj.status == 'success') {
						this.formIncomplete = false
						this.formId = obj.ffl_log_book_form_id
					} else {
						this.message = obj.message
					}
				})
			} else if (this.form_data.section_c) {
				this.formIncomplete = false
				this.formId = this.contact.ffl_log_book_form_id
			} else {
				if (!this.section_c.buyer_recertification_signature || !this.section_c.buyer_recertification_date) return
				let data = {
					ffl_log_book_form_id: this.formId,
					section_name: 'section_c',
					form: {
						form_data: {
							section_c: this.section_c
						}
					},
					source: 'LOGBOOKS',
					version: 1
				}
				this.apiCallLocal('save_4473_section', data).then(obj => {
					this.loading = false
					if (obj.status == 'success') {
						this.formIncomplete = false
						this.formId = this.contact.ffl_log_book_form_id
					} else {
						this.message = obj.message
					}
				})
			}
		},
		resetForm() {
			window.location.reload(true)
		},
		scroll(id) {
			var el = this.$el.querySelector('#' + id)
			var rect = el.getBoundingClientRect()
		    var scrollTop = window.pageYOffset || document.documentElement.scrollTop
		    var top = rect.top + scrollTop - 100 // 100 is just a buffer to give a bit of padding on top
		    // TODO: window.scroll needs polyfill for edge and IE
		    window.scroll({ top: top, left: 0, behavior: "smooth"})
		    el.classList.add('error')
		},
		removeError(id) {
			var el = this.$el.querySelector('#' + id)
			if (el.classList.contains('error')) {
				el.classList.remove('error')
			}
		},
		toggleHelp(index) {
			if (this.showHelp.indexOf(index) > -1) {
				this.showHelp.splice(this.showHelp.indexOf(index), 1)
			} else {
				this.showHelp.push(index)
			}
		},
		toggleInitial(object, value, data) {
			if (data != '' && this[object][value] != '') {
				this[object][value] = ''
			}
		},
		generatePDFLink() {
			return this.apiEndpoint + 'form_4473_pdf&source=logbooks&fd_token=' + this.$getCookie('dashboard_token') + '&form_id=' + this.randomString(6) + this.formId  + this.randomString(6)
		},
		// getCookie(name) {
		//     var re = new RegExp(name + "=([^;]+)");
		//     var value = re.exec(document.cookie);
		//     return (value != null) ? unescape(value[1]) : null;
		// },
		randomString(length) {
		    var text = ""
		    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz"
		    for(var i = 0; i < length; i++) {
		        text += possible.charAt(Math.floor(Math.random() * possible.length))
		    }
		    return text
		},
		goToDealerVersion() {
			var url = (document.location.origin.indexOf('cdsv2') > -1) ? 'https://cdsv2.test' : document.location.origin
			document.location.replace(url + "/logbooks/4473/" + this.formId)
		}
	}
}
</script>

<style lang="scss" scoped>
body {
	background: white;
}
.login, .form-options {
	padding: 0 0 3em 0;
}
label.checkbox {
	margin: 0 0.5em 1em 0.5em !important;
}
label.radio, label.checkbox {
	margin-bottom: 1em;
	max-width: max-content;
    display: inline-block !important;

    i.fa-check-circle {
    	color: lightgray;
    }

	input { display: none; }
    span:not(.on-value):not(.off-value) {
    	padding: 0.5em 0.3em;
	    border: 1px solid #d3d3d3;
	    color: #999;
	    border-radius: 5px;
	    background: #fafafa;
	    display: grid;
	    padding-right: 1em;
	    position: relative;
	    cursor: pointer;
	    grid-template-columns: 10px minmax(0, 1fr);
	    align-items: center;
	    grid-column-gap: 0.7rem;

        @media all and (min-width: 1026px) {
            padding: 0.5em 1em;
        }

	    &.more-info {
	    	grid-template-columns: 10px max-content 10px;
	    }
    }

    span.on-value { display: none; }

    &:hover span:not(.on-value):not(.off-value) {
    	background: #f0f0f0;
    }

    input[type="radio"]:checked ~ span, input[type="checkbox"]:checked ~ span {
    	background: #f0f0f0;
    	color: initial;
    	border-color: green;
    	i.fa-check-circle { color: green; }

    	span.on-value { display: inline-block; }
    	span.off-value { display: none; }
    }

    i.fa-info-circle {
    	display: inline-block;
    	color: #BBB;
    	position: relative;

    	span {
    	    display: none !important;
    	    position: absolute !important;
    	    min-width: fit-content;
    	    z-index: 1;
    	    min-width: max-content;
		    top: 0.4em;
		    left: 1.3em;
		    font-family: Helvetica;
		    font-weight: normal;
    	}

    	&:hover span { display: block !important; }
    }

    &.dark-font {
        margin-bottom: 0;
        //margin-top: 1.2em;
    }
}

.control-group {
    // display: grid;
    // grid-template-columns: repeat(auto, minmax(min-content, max-content));
    label.radio, label.checkbox {
        display: inline-block;
        float: left;

        span:not(.on-value):not(.off-value) {
            border-radius: 0;
            border-color: #BBB;
            border-left-width: 0;
            float: left;
        }

        &:first-child {
            span:not(.on-value):not(.off-value) {
                border-radius: 5px 0 0 5px;
                border-right: 1px solid #CCC;
                border-left-width: 1px;
            }
        }
        &:last-child {
            span:not(.on-value):not(.off-value) {
                border-radius: 0 5px 5px 0;
                border-left: none;
            }
        }
    }
}

.error {
	background: none !important;
	color: red !important;
}
select {
	font-size: 1.25em;
	padding: 0.25em;
}
p, h1, h2, label {
	font-family: sans-serif;
}
p {
	font-size: 0.7em;
	margin: 0;
}

a, .cancel-signature { cursor: pointer; }

label {
	font-size: 0.7em;
}

p.light-font, label.light-font {
	font-weight: bolder;
}

h1, h2 {
	margin: 0.25em 0;
	font-weight: 500;
    font-size: 1.5em;
    background: none;
    text-transform: none;
    padding: 0;
}

input[type=text], input[type=date], input[type=number], input[type=password] {
	height: 41px;
}

input[type=text], input[type=date], input[type=number], input[type=password], canvas#signature_pad {
	margin: 0;
	box-sizing: border-box;
	width: 95%;
	border: 1px solid #bfbfbf;
	font-size: 1.25em;
	color: #333;
    padding: 0.4em;
    border-radius: 5px;
}

input[disabled] {
    background: #E0E0E0;
}

input.half-input {
	width: 50%;
	display: block;
}

input.signature {
	height: 3em;
}

@media all and (min-width: 1024px) {
	p, label {
		font-size: 1em;
	}
	input[type=text], input[type=password] {
		width: 100%;
	}
}

.header {
	display: grid;
	grid-template-columns: 1fr 2fr;
	align-items: center;
	border-bottom: 1px solid #666;
}
.header img {
	margin: 0.5em;
	max-height: 2.5em;
}
.header h1 {
	text-align: right;
	font-family: 'Oswald', sans-serif;
	text-transform: uppercase;
	font-weight: 400;
	margin: 0.5em 1em;
	color: #333;
	font-size: 1.5em;
}

@media all and (min-width: 1024px) {
	.header h1 {
		font-size: 1.5em;
	}
}

.login {
	margin: 3em auto 4em auto;
	width: 30%;
}
.login label {
	margin-top: 1em;
	display: inline-block;
}
.note { font-size: 0.9em; margin: 2em 0; color: #666; }
.controls {
	margin-top: 1em;
}

.form-options {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 3rem;
    justify-content: center;
    width: 75%;
    margin: 5rem auto;
}

.three-one-columns {
    display: grid;
    grid-template-columns: 3fr 1fr;
    grid-column-gap: 1em;
}

.input-with-control {
    display: grid;
    grid-template-columns: 1fr 3em;

    .input-go {
     	height: 41px;
    }
}

.input-with-control input {
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
}

.options p {
    margin: 1.3rem 0;
    font-size: 0.9rem;
}

.options:nth-child(3) {
    grid-column: 1 / 3;
    width: 30%;
    margin: 0 auto;
}

.options .button { width: 100%; margin: 0; }

.search-result {
    margin: 0;
    padding: 0.5em;
    border-radius: 3px;
    height: 7.5em;
    line-height: 1.25em;
    position: relative;
    overflow-y: scroll;
    overflow-x: hidden;
    margin-top: 0.5rem;
}

.search-list {
	margin: 0;
	padding: 0;
    font-size: 0.85em;
    margin-bottom: 0.5em;
    line-height: 1em;
}
.search-list li {
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding: 0.25em 0;
    display: block;
}
.clickable-list-item {
    cursor: pointer;
    border-bottom: 1px dotted #dfdce3;
}
.clickable-list-item span {
	padding: 0 0.5em 0 0;
}
.clickable-list-item:hover {
    background-color: #dfebf4;
}
.no-results {
	margin: 2em 0 0 0;
	font-size: 1.25em;
	text-align: center;
	color: #999;
}

.bordered {
    border: 1px solid #dfdce3;
}

.intro-content {
	margin: 2em auto;
	padding: 0.5em;
}
.intro-content h1 {
	margin-top: 2em;
}

@media all and (min-width: 1024px) {
	.intro-content {
		padding: 0 4em;
	}
}

input[type=radio] {
	width: 20px;
	height: 20px;
}
.form-content {
	display: inline-grid;
	padding: 1em;
	grid-template-columns: 1fr 1fr 1fr 1fr;
	grid-template-rows: auto;
	grid-auto-flow: row;
	grid-column-gap: 0.75em;
	grid-row-gap: 0.75em;
	position: relative;
}
.form-content.show-help {
    grid-template-columns: 1fr 1fr 1fr 1fr 2fr;
}
.form-content .form-full {
    grid-column-end: span 4;
}
.form-content .form-full #race .checkbox-label {
    margin-right: 2em;
}
.form-content .form-full p.agreement {
    display: inline;
}
.form-content .form-quarter {
    grid-column-end: span 1;
    // align-self: end;
}
.form-content .form-quarter select {
	margin-bottom: 0.5em;
}
.form-content .form-quarter form.yes-or-no input[type='radio'] {
    margin-left: 2em;
}
.form-content .form-half {
    grid-column-end: span 2;
}
.form-content .form-threequarter {
    grid-column-end: span 3;
}
.form-content .form-threequarter #origin_country {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 1em;
}
.form-content .form-threequarter #origin_country input#usa {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
}
.form-content .form-threequarter #origin_country input#other {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
}
.form-content .form-threequarter #origin_country label.usa-label {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    margin-left: 1.75em;
}
.form-content .form-threequarter #origin_country label.other-label {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    margin-left: 1.75em;
}
.form-content .form-threequarter #origin_country input.other-input {
    grid-column: 2 / 3;
    grid-row: 2 / 3;
}
.form-content .form-threequarter #origin_country select {
    grid-column: 2 / 3;
    margin-bottom: 0.5em;
}
.form-content .line-break {
    grid-column-start: 1;
}
.help-box-outer {
	position: relative;
}
.help-box {
    padding: 1.6em 1em 1em 1em;
    margin: 1em 0 1em 0;
    font-size: 0.9em;
    font-weight: bold;
    z-index: 2;
    justify-self: start;
    color: #737375;
    background: #f4f4f4;
}
.help-box-label {
	float: right;
    margin: -0.75em 0 0 0;
    padding: 4px;
    background: #999;
    color: white;
    cursor: pointer;
}
.help-box-label:hover {
    opacity: 0.9;
}
.help-box-label-live {
    background: #b70000;
}

.help-box p {
    margin-bottom: 0.5em;
}
.help-box p:last-child {
    margin-bottom: 0;
}
.help-toggle {
	position: fixed;
    font-size: 0.8em;
    left: calc(100vw - 75px);
    bottom: 5em;
    cursor: pointer;
    text-transform: uppercase;
    transform: rotate(90deg);
    color: white;
    background: #bbb;
    padding: 0.5em 1em;
}
.help-toggle:hover {
	background: #aaa;
}
.help-toggle.active {
	background-color: #b70000;
}
.form-complete {
    width: 45%;
    margin: 2em auto;
    padding: 6em 0;
    text-align: center;
}
.form-complete a {
    text-decoration: none;
    height: 1em;
}

i.fas.fa-search {
    color: white;
}

@media all and (min-width: 768px) {
	.form-content {
		grid-row-gap: 1.25em;
	}
}

@media all and (min-width: 1024px) {
	.form-content {
		// width: 90%;
		padding: 4em;
		grid-column-gap: 3em;
		grid-row-gap: 2em;
		position: relative;
	}
	.form-content .form-threequarter #origin_country label.usa-label {
		margin-left: 2em;
	}
	.form-content .form-threequarter #origin_country label.other-label {
		margin-left: 2em;
	}
}
img.signature {
    max-height: 7em;
    max-width: 25em;
    width: auto;
}
.popover-container input[type=text] {
	width: 95%;
	border: 1px solid #bfbfbf;
	font-size: 1.25em;
}

[v-cloak] { display: none }

.signature {
	position: relative;
}

div.signature-group {
    display: grid;
    grid-template-columns: 25em 1em;
}

.tooltip {
    position: absolute;
    top: -1.5rem;
    right: 1rem;
    background: red;
    color: white;
    padding: 0.5rem;
    border-radius: 5px;
}
</style>
